import { Icons } from "../../../ds";

interface IExternalLinkButtonProps {
    href: string;
    text: string;
    /** Accessible name when the visible text is not enough ("Manage readers of Prod keys"). */
    "aria-label"?: string;
    /** `secondary` (default) or `link` (accent text, tables). */
    type?: "secondary" | "link";
    size?: "sm" | "md";
}

/**
 * DS gap: the library `Button` is a `<button>`; links to Identity Web (Manage readers, Manage access) must stay real `<a target=_blank>`
 * links (open in a new tab, copyable), so this is an anchor wearing the library's own button classes (`button secondary size-sm`),
 * with the external glyph after the text as the boards draw it. No local CSS.
 */
export function ExternalLinkButton(props: IExternalLinkButtonProps) {
    const type = props.type ?? "secondary";
    const size = props.size ?? "sm";
    return (
        <a
            className={`button ${type} size-${size} ark-external-link`}
            href={props.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={props["aria-label"]}
        >
            <span className="button-text">{props.text}</span>
            <Icons.external size={14} className="ark-external-link-icon" />
        </a>
    );
}
